module.exports = __webpack_public_path__ + "static/img/logo.8aa0d5de.png";